const AdditionalServices = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-[#FFF8F0] to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#2A2A2A] mb-6">
            Additional Value-Added Services
          </h2>
          <p className="text-lg text-[#6B6B6B] max-w-2xl mx-auto">
            Enhance your logistics experience with our comprehensive suite of additional services
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-white rounded-2xl p-8 shadow-lg border-l-4 border-[#FF8C42]">
            <div className="flex items-start">
              <div className="w-12 h-12 bg-[#FF8C42]/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-radar-line text-2xl text-[#FF8C42]"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-[#2A2A2A] mb-3">
                  Real-Time Tracking
                </h3>
                <p className="text-[#6B6B6B] leading-relaxed">
                  Monitor your shipments 24/7 with our advanced GPS tracking system. Receive real-time updates and notifications throughout the delivery process.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border-l-4 border-[#FF8C42]">
            <div className="flex items-start">
              <div className="w-12 h-12 bg-[#FF8C42]/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-file-list-3-line text-2xl text-[#FF8C42]"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-[#2A2A2A] mb-3">
                  Freight Documentation
                </h3>
                <p className="text-[#6B6B6B] leading-relaxed">
                  Complete documentation services including bills of lading, customs paperwork, and compliance documentation for seamless shipping.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border-l-4 border-[#FF8C42]">
            <div className="flex items-start">
              <div className="w-12 h-12 bg-[#FF8C42]/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-customer-service-2-line text-2xl text-[#FF8C42]"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-[#2A2A2A] mb-3">
                  Dedicated Account Management
                </h3>
                <p className="text-[#6B6B6B] leading-relaxed">
                  Work with a dedicated account manager who understands your business needs and provides personalized logistics solutions.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border-l-4 border-[#FF8C42]">
            <div className="flex items-start">
              <div className="w-12 h-12 bg-[#FF8C42]/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-calendar-check-line text-2xl text-[#FF8C42]"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-[#2A2A2A] mb-3">
                  Flexible Scheduling
                </h3>
                <p className="text-[#6B6B6B] leading-relaxed">
                  Accommodate your business schedule with flexible pickup and delivery windows tailored to your operational needs.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-[#FF8C42] to-[#D4693A] rounded-3xl p-12 text-white">
            <h3 className="text-3xl font-bold mb-4">
              Need a Custom Solution?
            </h3>
            <p className="text-lg mb-8 text-white/90">
              Our team can create tailored logistics solutions to meet your unique business requirements
            </p>
            <a
              href="tel:+13172460584"
              className="inline-block bg-white text-[#FF8C42] px-8 py-4 rounded-full text-lg font-bold hover:bg-[#FFF8F0] transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer"
            >
              Contact Our Team
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdditionalServices;